'use strict';

// Web shim for react-native-worklets initializers to avoid dynamic require usage

export function getMemorySafeCapturableConsole() {
  return console;
}

export function setupConsole() {
  // no-op on web
}

export function init() {
  // Ensure sane globals for web
  globalThis._WORKLET = false;
  globalThis._log = console.log;
  globalThis._getAnimationTimestamp = () => performance.now();
}
